var slidedown = {
	open: function( $item ) {
		var $content = $item.find( '.sd-content' ),
			h = $content.children( '.inner' ).outerHeight( true );

		$content.css( { 'max-height': h } );
		$( 'body' ).icons.init( '.svg-icon' );
	},
	close: function( $item ) {
		var $content = $item.find( '.sd-content' );
		$content.css( { 'maxheight': '0' } );
		setTimeout( function() {
				$item.removeClass( 'open' ).find( '.sd-content' ).removeAttr( 'style' );
		}, 300 );
	},
	openCloseContent: function() {
		if ( $( '.slidedown' ).length > 0 ) {
			$( '.sd-item > h3' ).on( 'click', function( e ) {
				e.preventDefault();
				var $item = $( this ).closest( '.sd-item' );
				if ( $item.hasClass( 'open' ) ) {
					slidedown.close( $item );
				} else {
					$item.siblings( 'li' ).each( function() {
						slidedown.close( $(this) );
					} );
					setTimeout( function() {
						slidedown.open( $item );
						$item.addClass( 'open' );
					}, 300 );
				}
			});
		}
	},
	init: function() {
		slidedown.openCloseContent();
		// If alreay open:
		$( '.sd-item' ).each( function() {
			var $item = $( this );
			if ( $item.hasClass( 'open' ) ) {
				slidedown.open( $item );
				// Fix:
				if ( $item.is( ':not(.open)' ) ) {
					$( '.sd-item.open' ).removeClass( 'open' ).find( '.sd-content' ).removeAttr( 'style' );
				}

			}


		} );
	},
};
